import { Component } from '@angular/core';

@Component({
  selector: 'app-tenant-invoice-show',
  template: ``,
  styleUrls: []
})
export class TenantInvoiceShowComponent {

}
